import { Trabalho } from '../..';
import { TipoTrabalho } from '../../contexts';
import { DetalheTrabalhoVO, FixtureTrabalho } from './trabalho.types';

export const trabalhoFixture: FixtureTrabalho = () => {
  const trabalhosMock: Trabalho[] = [
    {
      id: '1',
      entregas: [],
      titulo: 'trabalho link',
      obrigatorio: true,
      tipoTrabalho: TipoTrabalho.INDIVIDUAL,
      prazoEntrega: new Date(),
      temResposta: false,
      quantidadeMateriaisApoio: 1,
      avaliacao: {
        tipo: 'NENHUMA_CORRECAO',
      },
      permitirEnvioForaPrazo: true,
    },
    {
      id: '1',
      entregas: [],
      titulo: 'trabalho link',
      obrigatorio: true,
      tipoTrabalho: TipoTrabalho.INDIVIDUAL,
      prazoEntrega: new Date(),
      temResposta: false,
      quantidadeMateriaisApoio: 1,
      avaliacao: {
        tipo: 'NENHUMA_CORRECAO',
      },
      permitirEnvioForaPrazo: true,
    },
    {
      id: '1',
      entregas: [],
      titulo: 'trabalho link',
      obrigatorio: true,
      tipoTrabalho: TipoTrabalho.INDIVIDUAL,
      prazoEntrega: new Date(),
      temResposta: false,
      quantidadeMateriaisApoio: 1,
      avaliacao: {
        tipo: 'NENHUMA_CORRECAO',
      },
      permitirEnvioForaPrazo: true,
    },
  ];

  const trabalhosVOMock: DetalheTrabalhoVO[] = [
    {
      id: 'trabalho_123',
      titulo: 'Trabalho Titulo',
      enunciado: 'teste123123123',
      quantidadeMateriaisApoio: 1,
      tags: [],
      prazoEntrega: '28/12/2049',
      temResposta: false,
      entregas: [],
      obrigatorio: true,
      tipoTrabalho: TipoTrabalho.GRUPO,
      avaliacao: {
        tipo: 'NENHUMA_CORRECAO',
      },
    },
    {
      id: 'trabalho_123',
      titulo: 'Trabalho Titulo',
      enunciado: 'teste123123123',
      quantidadeMateriaisApoio: 1,
      tags: [],
      prazoEntrega: '28/12/2049',
      temResposta: false,
      entregas: [],
      obrigatorio: true,
      tipoTrabalho: TipoTrabalho.GRUPO,
      avaliacao: {
        tipo: 'NENHUMA_CORRECAO',
      },
    },
    {
      id: 'trabalho_123',
      titulo: 'Trabalho Titulo',
      enunciado: 'teste123123123',
      quantidadeMateriaisApoio: 2,
      tags: [],
      prazoEntrega: '28/12/2049',
      temResposta: false,
      entregas: [],
      obrigatorio: true,
      tipoTrabalho: TipoTrabalho.GRUPO,
      avaliacao: {
        tipo: 'NENHUMA_CORRECAO',
      },
    },
  ];

  return {
    trabalho: null,
    vo: null,
    getLista: function () {
      return trabalhosMock;
    },
    link: function () {
      this.trabalho = trabalhosMock[0];
      this.vo = trabalhosVOMock[0];
      return this;
    },
    arquivo: function () {
      this.trabalho = trabalhosMock[1];
      this.vo = trabalhosVOMock[1];
      return this;
    },
    linkEAqrquivo: function () {
      this.trabalho = trabalhosMock[2];
      this.vo = trabalhosVOMock[2];
      return this;
    },
    obrigatorio: function (param: boolean) {
      this.trabalho.obrigatorio = param;
      this.vo.tags.push('Obrigatório');
      return this;
    },
    entregas: function (param: string[]) {
      this.trabalho.entregas.concat(param);
      this.vo.entregas.concat(param);
      return this;
    },
    individual: function () {
      this.trabalho.tipoTrabalho = TipoTrabalho.INDIVIDUAL;
      this.vo.tipoTrabalho = TipoTrabalho.INDIVIDUAL;
      this.vo.tags.push('individual');
      return this;
    },
    emGrupo: function () {
      this.trabalho.tipoTrabalho = TipoTrabalho.GRUPO;
      this.vo.tipoTrabalho = TipoTrabalho.GRUPO;
      this.vo.tags.push('em grupo');
      return this;
    },
    prazo: function (param: Date) {
      this.trabalho.prazoEntrega = param;
      this.vo.prazoEntrega = `${param.getDay}/${param.getMonth}/${param.getFullYear}`;
      return this;
    },
    temResposta: function (param: boolean) {
      this.trabalho.temResposta = param;
      this.vo.temResposta = param;
      return this;
    },
    get: function () {
      return this.trabalho;
    },
    getVO: function () {
      return this.vo;
    },
  };
};
